import React, { Component } from "react";
import { HashRouter, Route, Switch } from "react-router-dom";
import "./scss/style.scss";
import * as firebase from "firebase";
import "firebase/auth";
import globalUtils from "./views/globalUntil";
import md5 from "md5";

const loading = (
  <div className="pt-3 text-center">
    <div className="sk-spinner sk-spinner-pulse"></div>
  </div>
);

// Containers
const TheLayout = React.lazy(() => import("./containers/TheLayout"));

// Pages
const Login = React.lazy(() => import("./views/pages/login/Login"));
const Register = React.lazy(() => import("./views/pages/register/Register"));
const Page404 = React.lazy(() => import("./views/pages/page404/Page404"));
const Page500 = React.lazy(() => import("./views/pages/page500/Page500"));
const firebaseConfig = {
  apiKey: "AIzaSyAdCCePj42yaNbdO3dauLA410uHwJu7GFc",
  authDomain: "door-fengshui.firebaseapp.com",
  projectId: "door-fengshui",
  storageBucket: "door-fengshui.appspot.com",
  messagingSenderId: "772108589009",
  appId: "1:772108589009:web:bbe7a6359712b53b4132f0",
  measurementId: "G-P9PFR94C77",
};
var database = {
  apiKey: "AIzaSyAqDXUKgULXkPDQIs2Le_beT6R0_JcmyY8",
  authDomain: "tmfs-yi-jing.firebaseapp.com",
  databaseURL: "https://tmfs-yi-jing.firebaseio.com",
  projectId: "tmfs-yi-jing",
  storageBucket: "tmfs-yi-jing.appspot.com",
  messagingSenderId: "331042421722",
  appId: "1:331042421722:web:862f72fc6b6c3ed5419ee3",
};
firebase.initializeApp(firebaseConfig);

var otherProject = firebase.initializeApp(database, "database");
var otherFirestore = otherProject.firestore();

// Đăng nhập Firebase Auth vào project "database" (tmfs-yi-jing) để có quyền
// đọc/ghi Firestore (Firestore Rules yêu cầu request.auth != null).
const AuthDB = () => {
  const auth = firebase.app("database").auth();
  auth
    .setPersistence(firebase.auth.Auth.Persistence.SESSION)
    .then(() => {
      return auth.signInWithEmailAndPassword(
        process.env.REACT_APP_EMAIL_AUTH,
        process.env.REACT_APP_PASS_AUTH
      );
    })
    .catch(() => {});
};
AuthDB();

otherFirestore
  .collection("redeem_code_Compass_Fengshui/")
  .get()
  .then((querySnapshot) => {
    querySnapshot.forEach((doc) => {
      // console.log(`1707${doc.id} => ${doc.data()}`);
    });
  });
class App extends Component {
  componentDidMount() {}
  render() {
    return (
      <HashRouter>
        <React.Suspense fallback={loading}>
          <Switch>
            <Route
              exact
              path="/login"
              name="Login Page"
              render={(props) => <Login {...props} />}
            />
            <Route
              exact
              path="/register"
              name="Register Page"
              render={(props) => <Register {...props} />}
            />
            <Route
              exact
              path="/404"
              name="Page 404"
              render={(props) => <Page404 {...props} />}
            />
            <Route
              exact
              path="/500"
              name="Page 500"
              render={(props) => <Page500 {...props} />}
            />
            <Route
              path="/"
              name="Home"
              render={(props) => <TheLayout {...props} />}
            />
          </Switch>
        </React.Suspense>
      </HashRouter>
    );
  }
}

export default App;
